export const furnitureProducts = [
  {
    id: 'f1',
    name: 'Oslo Designer Sofa',
    nameUA: 'Дизайнерський диван Oslo',
    category: 'furniture',
    price: 45999,
    image: 'https://images.unsplash.com/photo-1540932428079-887d0d7a8fa5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBmdXJuaXR1cmV8ZW58MHx8fHwxNzY1MDU4MTc1fDA&ixlib=rb-4.1.0&q=85',
    description: 'Luxurious leather sofa with Italian craftsmanship',
    descriptionUA: 'Розкішний шкіряний диван італійської роботи',
    inStock: true,
    featured: true,
    new: true,
    specs: {
      material: 'Italian Leather',
      dimensions: '240 x 95 x 85 cm',
      color: 'Brown',
      warranty: '5 years'
    }
  },
  {
    id: 'f2',
    name: 'Elegance Wooden Sideboard',
    nameUA: 'Дерев\'яна тумба Elegance',
    category: 'furniture',
    price: 28500,
    image: 'https://images.unsplash.com/photo-1540759772348-12e90305e8f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBmdXJuaXR1cmV8ZW58MHx8fHwxNzY1MDU4MTc1fDA&ixlib=rb-4.1.0&q=85',
    description: 'Handcrafted oak sideboard with elegant design',
    descriptionUA: 'Дубова тумба ручної роботи з елегантним дизайном',
    inStock: true,
    featured: true,
    specs: {
      material: 'Oak Wood',
      dimensions: '180 x 45 x 80 cm',
      color: 'Natural',
      warranty: '3 years'
    }
  },
  {
    id: 'f3',
    name: 'Minimalist Leather Sofa',
    nameUA: 'Мінімалістичний шкіряний диван',
    category: 'furniture',
    price: 38900,
    image: 'https://images.unsplash.com/photo-1567016376408-0226e4d0c1ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBmdXJuaXR1cmV8ZW58MHx8fHwxNzY1MDU4MTc1fDA&ixlib=rb-4.1.0&q=85',
    description: 'Modern black leather sofa with clean lines',
    descriptionUA: 'Сучасний чорний шкіряний диван з чистими лініями',
    inStock: true,
    featured: false,
    specs: {
      material: 'Premium Leather',
      dimensions: '220 x 90 x 75 cm',
      color: 'Black',
      warranty: '5 years'
    }
  },
  {
    id: 'f4',
    name: 'Premium Living Set',
    nameUA: 'Преміальний набір меблів',
    category: 'furniture',
    price: 89900,
    image: 'https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBmdXJuaXR1cmV8ZW58MHx8fHwxNzY1MDU4MTc1fDA&ixlib=rb-4.1.0&q=85',
    description: 'Complete sectional sofa set for modern living',
    descriptionUA: 'Повний набір секційних меблів для сучасного життя',
    inStock: true,
    featured: true,
    new: true,
    specs: {
      material: 'Fabric & Leather',
      dimensions: '350 x 200 x 80 cm',
      color: 'Gray',
      warranty: '7 years'
    }
  },
  {
    id: 'f5',
    name: 'Artistic Designer Chair',
    nameUA: 'Дизайнерське крісло',
    category: 'furniture',
    price: 15900,
    image: 'https://images.unsplash.com/photo-1688233126609-de4f39b06f95?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxkZXNpZ25lciUyMGNoYWlyfGVufDB8fHx8MTc2NTA1ODE4MHww&ixlib=rb-4.1.0&q=85',
    description: 'Unique wooden designer chair for statement pieces',
    descriptionUA: 'Унікальне дерев\'яне дизайнерське крісло',
    inStock: true,
    featured: false,
    specs: {
      material: 'Solid Wood',
      dimensions: '60 x 55 x 85 cm',
      color: 'Natural Wood',
      warranty: '2 years'
    }
  },
  {
    id: 'f6',
    name: 'Modern Accent Chair',
    nameUA: 'Сучасне акцентне крісло',
    category: 'furniture',
    price: 12500,
    image: 'https://images.pexels.com/photos/8373803/pexels-photo-8373803.jpeg',
    description: 'Bold contemporary chair in vibrant colors',
    descriptionUA: 'Яскраве сучасне крісло в насичених кольорах',
    inStock: true,
    featured: false,
    new: true,
    specs: {
      material: 'Velvet & Metal',
      dimensions: '70 x 65 x 90 cm',
      color: 'Orange',
      warranty: '2 years'
    }
  }
];

export const electronicsProducts = [
  {
    id: 'e1',
    name: 'iPhone 17 Pro Max',
    nameUA: 'iPhone 17 Pro Max',
    category: 'electronics',
    price: 52999,
    image: 'https://images.unsplash.com/photo-1758186370179-5b033011187b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwZWxlY3Ryb25pY3N8ZW58MHx8fHwxNzY1MDU4MjA0fDA&ixlib=rb-4.1.0&q=85',
    description: 'Latest flagship smartphone with advanced AI capabilities',
    descriptionUA: 'Найновіший флагманський смартфон з просунутими AI можливостями',
    inStock: true,
    featured: true,
    new: true,
    specs: {
      processor: 'A18 Bionic',
      storage: '512GB',
      camera: '48MP Pro Camera System',
      display: '6.7" Super Retina XDR',
      warranty: '1 year'
    }
  },
  {
    id: 'e2',
    name: 'MacBook Pro 16"',
    nameUA: 'MacBook Pro 16"',
    category: 'electronics',
    price: 89999,
    image: 'https://images.unsplash.com/photo-1758979792186-32a5da91f24d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwZWxlY3Ryb25pY3N8ZW58MHx8fHwxNzY1MDU4MjA0fDA&ixlib=rb-4.1.0&q=85',
    description: 'Professional laptop with M4 Max chip',
    descriptionUA: 'Професійний ноутбук з чіпом M4 Max',
    inStock: true,
    featured: true,
    specs: {
      processor: 'Apple M4 Max',
      ram: '64GB',
      storage: '2TB SSD',
      display: '16.2" Liquid Retina XDR',
      warranty: '1 year'
    }
  },
  {
    id: 'e3',
    name: 'iPhone 16 Pro Titanium',
    nameUA: 'iPhone 16 Pro Titanium',
    category: 'electronics',
    price: 48900,
    image: 'https://images.unsplash.com/photo-1727093493864-0bcbd16c7e6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwZWxlY3Ryb25pY3N8ZW58MHx8fHwxNzY1MDU4MjA0fDA&ixlib=rb-4.1.0&q=85',
    description: 'Premium smartphone with titanium finish',
    descriptionUA: 'Преміальний смартфон з титановим корпусом',
    inStock: true,
    featured: false,
    specs: {
      processor: 'A17 Pro',
      storage: '256GB',
      camera: '48MP Triple Camera',
      display: '6.3" OLED ProMotion',
      warranty: '1 year'
    }
  },
  {
    id: 'e4',
    name: 'iPad Pro 12.9" Bundle',
    nameUA: 'iPad Pro 12.9" комплект',
    category: 'electronics',
    price: 62500,
    image: 'https://images.unsplash.com/photo-1726644930461-124e81e10c6f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBnYWRnZXRzfGVufDB8fHx8MTc2NTA1ODIwOXww&ixlib=rb-4.1.0&q=85',
    description: 'Professional tablet with Apple Pencil Pro',
    descriptionUA: 'Професійний планшет з Apple Pencil Pro',
    inStock: true,
    featured: true,
    new: true,
    specs: {
      processor: 'M3 Chip',
      storage: '1TB',
      display: '12.9" Liquid Retina XDR',
      accessories: 'Apple Pencil Pro included',
      warranty: '1 year'
    }
  },
  {
    id: 'e5',
    name: 'Premium Tech Setup',
    nameUA: 'Преміальний технічний набір',
    category: 'electronics',
    price: 38900,
    image: 'https://images.unsplash.com/photo-1737107310914-25c68a7f1a49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBnYWRnZXRzfGVufDB8fHx8MTc2NTA1ODIwOXww&ixlib=rb-4.1.0&q=85',
    description: 'Complete tech bundle with tablet and smartwatch',
    descriptionUA: 'Повний технологічний набір з планшетом та смарт-годинником',
    inStock: true,
    featured: false,
    specs: {
      includes: 'Tablet + Smartwatch + Stylus',
      connectivity: '5G & WiFi 6E',
      warranty: '2 years'
    }
  },
  {
    id: 'e6',
    name: 'JBL Premium Speaker',
    nameUA: 'Преміум колонка JBL',
    category: 'electronics',
    price: 8900,
    image: 'https://images.unsplash.com/photo-1690455422058-156a39f18a0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBnYWRnZXRzfGVufDB8fHx8MTc2NTA1ODIwOXww&ixlib=rb-4.1.0&q=85',
    description: 'High-fidelity wireless speaker with premium sound',
    descriptionUA: 'Високоякісна бездротова колонка з преміум звуком',
    inStock: true,
    featured: false,
    new: true,
    specs: {
      audio: 'Hi-Res Audio',
      battery: '24 hours',
      connectivity: 'Bluetooth 5.3',
      waterproof: 'IP67',
      warranty: '1 year'
    }
  }
];

export const allProducts = [...furnitureProducts, ...electronicsProducts];

export const getProductById = (id) => allProducts.find(p => p.id === id);
export const getFeaturedProducts = () => allProducts.filter(p => p.featured);
export const getNewProducts = () => allProducts.filter(p => p.new);
export const getProductsByCategory = (category) => allProducts.filter(p => p.category === category);